export default __webpack_public_path__ + "static/media/SFG-Web-GlyGen-Nov-2019.ee327b32.pdf";